<svg class="video-placeholder"
  *ngIf="contentBlock.videoBlock == null || (contentBlock.videoBlock.assetId == null && (contentBlock.videoBlock.url == '' || contentBlock.videoBlock.url == null))"
  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" enable-background="new 0 0 100 100">
  <path fill="#B2B3B3"
    d="M42.6 74.2l-7.5-.3-7.5-.6c-2.5-.2-5-.5-7.5-.8-.3-.1-.5-.2-.8-.4-.2-.2-.4-.4-.4-.7-.9-3.6-1.6-7.2-2-10.8-.4-3.6-.6-7.2-.6-10.7 0-3.6.2-7.1.6-10.7.4-3.6 1.1-7.1 2-10.7.1-.3.2-.6.4-.8.2-.2.5-.3.8-.4 5-.6 10-1 14.9-1.3 5-.3 10-.5 14.9-.5 5 0 10 .2 14.9.5 5 .3 10 .7 14.9 1.3.3.1.5.2.8.4.2.2.4.5.4.8.9 3.5 1.6 7.1 2 10.7.4 3.6.6 7.2.6 10.7 0 3.6-.2 7.1-.6 10.7-.4 3.6-1.1 7.2-2 10.8-.1.3-.2.5-.4.7-.2.2-.5.3-.8.4l-7.5.8-7.5.6c-2.5.2-5 .3-7.5.3-2.5.1-5 .1-7.4.1-2.3 0-4.7 0-7.2-.1zm-6.9-3.2c4.8.3 9.5.4 14.3.4 4.8 0 9.5-.1 14.3-.4 4.8-.3 9.5-.7 14.2-1.2.8-3.3 1.4-6.6 1.7-9.9.4-3.3.5-6.6.5-9.9 0-3.3-.2-6.6-.5-9.9-.4-3.3-.9-6.6-1.7-9.9-4.7-.5-9.4-.9-14.2-1.2-4.8-.3-9.5-.4-14.3-.4-4.8 0-9.5.1-14.3.4-4.8.3-9.5.7-14.2 1.2-.8 3.3-1.4 6.6-1.7 9.9-.4 3.3-.5 6.6-.5 9.9 0 3.3.2 6.6.5 9.9.4 3.3.9 6.6 1.7 9.9 4.7.5 9.5.9 14.2 1.2zm6.5-8.9c-.6-.5-.8-1.2-.8-2.2v-19.8c0-1.4.5-2.3 1.5-2.7 1-.4 1.9-.3 2.9.2l17.1 9.9c.5.3.9.6 1.2 1.1.3.4.4.9.4 1.4 0 .4-.1.9-.4 1.3-.3.4-.7.8-1.2 1.1l-17.1 9.9c-.3.2-.6.3-.8.4-.3.1-.6.1-.8.1-.8.1-1.5-.2-2-.7zm2.1-2.3l17-9.7-16.9-9.8-.1 19.5z" />
</svg>

<span
  *ngIf="contentBlock.videoBlock != null && contentBlock.videoBlock.url != '' && contentBlock.videoBlock.url != null"
  [ngSwitch]="contentBlock.videoBlock.videoType">

  <span *ngSwitchCase="2">
    <iframe width="100%" appResizePreviewImage [src]="primaryUrl | safe:'resourceUrl'" title=""
      allowfullscreen></iframe>
  </span>
  <span *ngSwitchCase="1">
    <iframe width="100%" appResizePreviewImage [src]="primaryUrl | safe:'resourceUrl'" title="" webkitAllowFullScreen
      mozallowfullscreen allowFullScreen></iframe>
  </span>
  <span *ngSwitchCase="0">
    <ng-container *ngIf="!contentBlock.videoBlock.assetId">
      <span [hidden]="!isPlaying">
        <app-vplaybook-video-viewer width="100%" *ngIf="primaryUrl" [setVideoSrc]="primaryUrl"
          [setIsPlaying]="isPlaying" [isLoadVideo]="false" [isEmbedThirdPartyUrl]="!!contentBlock.videoBlock.url">
        </app-vplaybook-video-viewer>
      </span>
      <span #videoCont *ngIf="!isPlaying" appResizePreviewImage [ngStyle]="thumbNailStyle"
        class="playbook-video-placeholder">
        <a (click)="playVideo()" class="play-button"></a>
      </span>
    </ng-container>
    <ng-container *ngIf="contentBlock.videoBlock.assetId">
      <span [hidden]="!isPlaying">
        <app-vplaybook-video-viewer width="100%"
          *ngIf="contentBlock.videoBlock != null && contentBlock.videoBlock.assetId != '' "
          [videoAssetId]="contentBlock.videoBlock.assetId"
          [setVideoSrc]="'/api/Assets/GetResourceById/' + contentBlock.videoBlock.assetId" [setIsPlaying]="isPlaying"
          [isLoadVideo]="false">
        </app-vplaybook-video-viewer>
      </span>
      <span #videoCont *ngIf="!isPlaying" appResizePreviewImage [ngStyle]="thumbNailStyle"
        class="playbook-video-placeholder">
        <a (click)="playVideo()" class="play-button"></a>
      </span>
    </ng-container>

  </span>
</span>

<ng-template #AddEditVideo>
  <div *ngIf="vidBlock" class="modal-content modal-lg">
    <div class="modal-header">
      Edit Video
      <i class="material-icons" data-bs-dismiss="modal" (click)='closeEditVideoModal()'>close</i>
    </div>
    <div class="modal-body me-3">
      <div class="form-group row align-items-center mt-1">
        <label class="col-sm-2 control-label">Source</label>
        <div class="col-sm-10">
          <div class="btn-group" btnRadioGroup id="SourceTypeId">
            <label btnRadio="false" (click)="vidBlock.external = false;"
              [ngClass]="{'btn__active': vidBlock.external == false}" class="btn btn__outline"
              role="button">File</label>
            <label btnRadio="true" (click)="vidBlock.external = true;"
              [ngClass]="{'btn__active': vidBlock.external == true}" class="btn btn__outline" role="button">URL</label>
          </div>
        </div>
      </div>

      <div class="form-group row align-items-center mt-1">
        <label class="col-sm-2 control-label">Video Title</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" [(ngModel)]="vidBlock.videoTitle" />
        </div>
      </div>

      <div class="form-group row align-items-center mt-1">
        <label class="col-sm-2 control-label">Talent Name</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" [(ngModel)]="vidBlock.talentName" />
        </div>
      </div>

      <div class="form-group row align-items-center mt-1">
        <label class="col-sm-2 control-label">Description</label>
        <div class="col-sm-10">
          <textarea class="form-control" type="text" [(ngModel)]="vidBlock.description"></textarea>
        </div>
      </div>

      <div class="form-group" *ngIf="!vidBlock.external" style="margin-top: 30px;">
        <div class="row">
          <label class="col-sm-2 control-label">Video</label>
          <div class="col-sm-5" [ngStyle]="{'margin-top': vidBlock.assetId ? '-30px' : '0px'}">
            <i [hidden]="!vidBlock.assetId" class="material-icons pull-right mt-10 pointer"
              (click)="removeAsset(1)">delete</i>
            <div class="upload-assets">
              <div (click)="openFileDialog(1)" class="upload-assets-file">
                <div class="upload-box">
                  <span class="material-icons upload-icon upload-icon-color"
                    *ngIf="!vidBlock.assetId">cloud_upload</span>
                  <app-vplaybook-video-viewer *ngIf="vidBlock.assetId" style="width: 100%; height:100%;"
                    [setIsPlaying]="false" [videoAssetId]="vidBlock.assetId" [setVideoSrc]="getAssetSrc(1)">
                  </app-vplaybook-video-viewer>
                </div>
                <div class="file-upload hide">
                  <app-video-chunks-upload (progressPercentage)="progressPercentage($event)"
                    [chunksClass]="'file-upload__input'" (fileStatusUpdate)="fileStatusUpdate($event)"
                    [apiUrl]="apiUrl">
                  </app-video-chunks-upload>
                </div>
              </div>
              <section class="modal-pop" *ngIf="showProgress.mp4" style="position:relative !important;">
                <div class="progress progress-striped active">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [attr.aria-valuenow]="progressPercent.mp4" aria-valuemin="0" aria-valuemax="100"
                    [ngStyle]="!videoProcessing && {'width' : progressPercent.mp4+'%'} || {'width' : '100%'}"
                    [ngClass]="(progressPercent.mp4) ? 'white-font' : 'show-initial-status'">
                    {{ !videoProcessing ? progressPercent.mp4 + '%' : ''}} {{videoProcessing}}
                  </div>

                </div>
              </section>
              <span class="video-file-name align-content-end" title="{{vidBlock.asset?.name || 'Upload MP4 Video'}}">
                {{(vidBlock.asset?.name || "Upload MP4 Video") }}
              </span>
            </div>
          </div>
          <div class="col-sm-5" [ngStyle]="{'margin-top': vidBlock.placeHolderImageId ? '-30px' : '0px'}">
            <i [hidden]="!vidBlock.placeHolderImageId" class="material-icons pull-right mt-10 pointer"
              (click)="removeAsset(3)">delete</i>
            <div class="upload-assets">
              <div (click)="openFileDialog(3)" class="upload-assets-file">
                <div *ngIf="!vidBlock.placeHolderImageId; else imgselected" class="upload-box pointer"
                  title="click to change file">
                  <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
                </div>
                <ng-template #imgselected>
                  <img id="imgBackground" title="click to change file"
                    [ngStyle]="{'width': vidBlock.placeHolderImageId ? 'auto' : '100%'}" class="upload-box pointer"
                    [src]="getAssetSrc(3) | loadSecureAssets  : true | async" alt="" />
                </ng-template>
                <div class="file-upload hide">
                  <input id="uploadplaceholder" #fileInput (click)="fileInput.value = null"
                    (change)="fileSelected($event,3)" accept="image/jpg, image/jpeg, image/png"
                    class="file-upload__input" type="file" name="preview-file-upload">

                </div>
              </div>
              <section class="modal-pop" *ngIf="showProgress.image" style="position:relative !important;">
                <div class="progress progress-striped active">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [attr.aria-valuenow]="progressPercent.image" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="progressPercent.image+'%'">
                    {{progressPercent.image}}%
                  </div>
                </div>
              </section>
              <span class="video-file-name align-content-end"
                title="{{vidBlock.placeHolderImage?.name || 'Upload JPEG or PNG'}}">
                {{(vidBlock.placeHolderImage?.name || "Upload JPEG or PNG") }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2 align-items-center form-group" *ngIf="vidBlock.external">
        <label class="col-sm-2 control-label" for="url">Video URL</label>
        <div class="col-sm-10">
          <input type="text" [(ngModel)]="vidBlock.url" class="form-control vplaybook__form__inputs">
        </div>
        <ng-container *ngIf="checkVideoUrl(vidBlock.url)">
          <label class="col-sm-2 control-label" for="url">PlaceHolder</label>
          <div class="col-sm-10">
            <i [hidden]="!vidBlock.placeHolderImageId" class="material-icons pull-right mt-10 pointer"
              (click)="removeAsset(3)">delete</i>
            <div class="upload-assets">
              <div (click)="openFileDialog(3)" class="upload-assets-file">
                <div *ngIf="!vidBlock.placeHolderImageId; else imgselected" class="upload-box pointer"
                  title="click to change file">
                  <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
                </div>
                <ng-template #imgselected>
                  <img id="imgBackground" title="click to change file"
                    [ngStyle]="{'width': vidBlock.placeHolderImageId ? 'auto' : '100%'}" class="upload-box pointer"
                    [src]="getAssetSrc(3) | loadSecureAssets  : true | async" alt="" />
                </ng-template>
                <div class="file-upload hide">
                  <input id="uploadplaceholder" #fileInput (click)="fileInput.value = null"
                    (change)="fileSelected($event,3)" accept="image/jpg, image/jpeg, image/png"
                    class="file-upload__input" type="file" name="preview-file-upload">

                </div>
              </div>
              <section class="modal-pop" *ngIf="showProgress.image" style="position:relative !important;">
                <div class="progress progress-striped active">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [attr.aria-valuenow]="progressPercent.image" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="progressPercent.image+'%'">
                    {{progressPercent.image}}%
                  </div>
                </div>
              </section>
              <span class="video-file-name align-content-end"
                title="{{vidBlock.placeHolderImage?.name || 'Upload JPEG or PNG'}}">
                {{(vidBlock.placeHolderImage?.name || "Upload JPEG or PNG") }}
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal"
        (click)='closeEditVideoModal()'>Cancel</button>
      <button type="button" class="btn btn__btn-default btn__orange"
        [ngStyle]="(isProgressing.mp4 || isProgressing.image) && {'cursor':'not-allowed'} || {'cursor':'pointer'}"
        [disabled]="isProgressing.mp4 || isProgressing.image" (click)="updateVideoBlock()">Save</button>
    </div>
  </div>
</ng-template>